import { createReducer, on } from '@ngrx/store';
import * as actions from '../actions/auth.actions';

// CHange "any" to whatever the user model will be in the future.
export interface AuthState {
  profile: any;
  currentAccount: any;
}

//  Create the initial state for the authenticated user.
const initialAuthState: AuthState = {
  profile: null,
  currentAccount: null
};

export const reducer = createReducer(
  initialAuthState,
  on(actions.authUserLogin, (state, action) => {
    return {
      ...state,
      profile: action.profile
    };
  }),
  on(actions.authAccountToggle, (state, action) => {
    return {
      ...state,
      currentAccount: action.currentAccount
    };
  }),
  on(actions.authUserLogout, (state) => {
    return initialAuthState;
  }),
);
